
export default {
  name: 'VsVideo',
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: null
    },
    src: {
      type: String,
      default: null
    },
    ratio: {
      type: [String, Boolean, Object],
      default: '16/9'
    },
    fit: {
      type: [String, Object],
      default: 'cover'
    },
    controls: {
      type: [String, Boolean],
      default: false
    }
  },
  vessel: {
    ratio: {
      $attrs: ['width', 'height'],
    },
    video: {
      $attrs: 'all',
      display: 'block',
      width: 'full',
      height: 'full',
      $fit: 'objectFit'
    },
    slot: {
      position: 'absolute',
      pin: true,
      width: 'full',
      height: 'full',
      pointerEvents: 'none'
    }
  },
  data() {
    return {
      hasData: false
    }
  },
  computed: {
    href() {
      return this.src || this.source
    },
    hasContent() {
      const slots = this.$slots.default
      return slots && slots.length
    }
  },
  methods: {
    onReady(event) {
      this.hasData = true

      this.$emit('load', event)
      this.$emit('loadeddata', event)
    }
  }
}
